@if (formRevision) {
    <entity-attachments
        [(hasAttachments)]="formRevision.hasAttachments"
        buttonClass="has-icon mb-0"
        [modalData]="getAttachmentModalData()">
    </entity-attachments>
}
